import ContentTypeDescription from './component'
export default ContentTypeDescription
